import Text from "components/Text";
import styled from "styled-components";
import theme from "theme";
import { motion } from "framer-motion";

export const Left = styled.div`
    background-color: #fff;
    padding: 16px 14px;
    box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.05);
    border-radius: 20px;
    grid-area: sidenav;
    margin: 0 14px;

    @media (${theme.breakpoints.mobileL}) {
        margin: unset;
        border-radius: unset;
        position: fixed;
        bottom: 0;
        left: 0;
        z-index: 99;
        width: 100%;
    }
`;

export const MinMaxInput = styled.div`
    display: flex;
    align-items: center;
    gap: 1rem;
`;

export const Dash = styled(Text)`
    margin-top: 2rem;
`;

export const MobileButtonsMenu = styled(motion.div)``;

export const MobileButtons = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const MobileFilterButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 10px;
    font-family: "Montserrat", sans-serif;
    font-size: 14px;
    font-weight: 600;
    line-height: 17px;
    letter-spacing: 0em;
    text-align: center;
    color: #7b7187;
    background-color: unset;
    width: 100%;
`;

export const VerticalSeparator = styled.div`
    width: 1px;
    background: #e8e5eb;
    height: 30px;
`;

export const Menu = styled(motion.div)``;

export const ApplyResetButtons = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
`;

export const Buttons = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
`;

export const SortMenu = styled(Menu)`
    height: 280px;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`;

export const SortMenuUpper = styled(SortMenu)`
    height: 100%;
`;
